/**
 * @param {AxiosInstance} api
 * @param {string} [search]
 * @return {Promise<string[]>}
 */
import { merge } from 'lodash';

export async function listProductCategories(api, options) {
  return (await api.get('v1/admin/productCategories', { params: merge({ limit: 100 }, options) }))
    .data.docs;
}

export async function listPhysicalProducts(api, options) {
  return (await api.get('v1/admin/PhysicalProducts/', { params: options })).data;
}
